module.exports = __webpack_public_path__ + "img/banner.236a2783.png";